export function removeChildrenOf(items, ids) {
    const excludeParentIds = [...ids];
    return items.filter((item) => {
        if (item.parentId && excludeParentIds.includes(item.parentId)) {
            if (item.original.children?.length) {
                excludeParentIds.push(item.id);
            }
            return false;
        }
        return true;
    });
}
export function flattenTree(items) {
    return flatten(items);
}
export function flatten(items, parentId = null, depth = 0) {
    return items.reduce((acc, item, index) => {
        const flattened = {
            id: item.id,
            parentId,
            original: item,
            depth,
            collapsed: !!item.collapsed,
            index,
        };
        const flattenedChildren = flatten(item.children ?? [], item.id, depth + 1);
        return [...acc, flattened, ...flattenedChildren];
    }, []);
}
